import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationExtras } from "@angular/router";

import { AlertComponent } from "ngx-bootstrap/alert/alert.component";
import { ImageViewerConfig } from "ngx-image-viewer";

import { PackageReceptionDet } from "../../../common/model/PackageReceptionDet";
import { PackageReceptionFacade } from "../../../common/facade/PackageReceptionFacade";
import { BlobStorageFacade } from "../../../common/facade/BlobStorageFacade";
import { Strings } from "../../../common/language/strings";
import { res } from "../../../common/language/text/res";

@Component({
  selector: "app-receptions-detail",
  templateUrl: "./receptions-detail.component.html",
  styleUrls: ["./receptions-detail.component.css"],
})
export class ReceptionsDetailComponent implements OnInit {
  @ViewChild("photoModal") photoModal;
  loading = false;
  messageLoader = "";
  // alert
  alerts = [];
  rows: PackageReceptionDet[];
  private _filteredData: PackageReceptionDet[];
  packageReceptionId = 0;
  receptionDate = new Date();
  employeeName = "";
  totalDetail = 0;
  totalDetailByAsn = 0;
  totalDetailWithoutAsn = 0;
  comment = "";
  imageIndexOne = 0;
  configImageViewer: ImageViewerConfig = { customBtns: [] };
  photos_gallery: any = [];
  photos: number[];
  storeId: number;
  organizationId: string;
  idcode: number;
  public extras: NavigationExtras;
  public path = "inventory/receptions";

  titleReferenceReception = res.ReferenceReception;
  lblReception = res.Reception;
  lblReceivedBy = res.ReceivedBy;
  lblShippingNumberReceived = res.ShippingNumberReceived;
  lblShippingNumberReceivedByAsn = res.ShippingNumberReceivedByASN;
  lblShippingNumberReceivedWithoutAsn = res.ShippingNumberReceivedWithoutASN;
  lblSearch = res.Search;
  lblShippingNumber = res.ShippingNumber;
  lblStatus = res.Status;
  lblDelivery = res.Delivery;
  lblComments = res.Comments;
  lblPhotos = res.Photos;
  lblViewComments = res.ViewComments;
  lblViewPhotos = res.ViewPhotos;
  lblClose = res.Close;
  lblCartonCode = res.CartonCode;
  lblASNCode = res.ASNCode;

  isSpanish = true;
  showCartonCodeColumn = false;
  showAsnCodeColumn = false;
  showOnlyTotal = false;
  showOnlyByAsn = false;
  showBothAsnLabels = false;

  messagesTable: any = {
    emptyMessage: "",
    totalMessage: "",
  };

  constructor(
    private _facade: PackageReceptionFacade,
    private _facadeBlobStorage: BlobStorageFacade,
    private _activatedRoute: ActivatedRoute,
    public strings: Strings
  ) {}

  ngOnInit() {
    this.loading = true;

    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(
      res.ThereIsNoInformation
    );
    this.messagesTable.totalMessage = "Total";

    const id = this._activatedRoute.snapshot.paramMap.get("id");

    this._activatedRoute.queryParams.subscribe((params) => {
    this.idcode = Number(params["id"]);
    this.storeId = Number(params["storeid"]);
    this.organizationId = params["orgId"];
      
      this.extras = {
        queryParams: {
          idcode: this.idcode,
          storeid: this.storeId,
          orgId: this.organizationId,
        },
      };
    });

    console.log("idcode: " + this.idcode + " storeid: " + this.storeId + "org: " + this.organizationId)
    this._facade.GetWithASNById(id).subscribe(
      (result) => {      
        if (result.completed) {
          this.packageReceptionId = result.data.packageReceptionId;
          this.receptionDate = result.data.receptionDate;
          this.employeeName =
            result.data.employeeId + " " + result.data.employeeName;
          this.totalDetail = result.data.detail.length;
          // this.comment = result.data.comment;
          // this.photos = result.data.photos;

          this.storeId = result.data.storeId;
          this.rows = result.data.detail;
          this._filteredData = result.data.detail;
          this.showCartonCodeColumn = result.data.detail.some(row => row.cartonCode?.trim());
          this.showAsnCodeColumn = result.data.detail.some(row => row.shipmentAsnCode?.trim());
          
          const withAsn = result.data.detail.filter(row => row.isAsn).length;
          const withoutAsn = result.data.detail.length - withAsn;
          
          if (withAsn === 0) {
            this.showOnlyTotal = true;
          } else if (withoutAsn === 0) {
            this.showOnlyByAsn = true;
            this.totalDetailByAsn = withAsn;
          } else {
            this.showBothAsnLabels = true;
            this.totalDetailByAsn = withAsn;
            this.totalDetailWithoutAsn = withoutAsn;
          }
          
          // this.showComments = !(this.comment.length > 0);
          // this.getBlobPhotos();
          if (!this.isSpanish) {
            result.data.detail.forEach((row) => {
              row.statusPackage = row.statusPackageEn;
            });
          }
          this.loading = false;
        } else {
          this.addAlert(
            "<strong>" +
              this.strings.GetText(res.AlertErrorGettingInformation) +
              "</strong>",
            "danger"
          );
          this.loading = false;
        }
      },
      (error) => {
        this.addAlert("<strong>" + error + "</strong>", "danger");
        this.loading = false;
      }
    );
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message,
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
  }

  setComments(comment) {
    this.comment = comment;
  }

  setPhotos(photos) {
    this.photos = photos;
    this.getBlobPhotos();
  }

  getBlobPhotos() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingImages);
    this.photos_gallery = [];
    this.imageIndexOne = 0;
    if (this.photos.length > 0) {
      this.photos.forEach((idPhoto) => {
        this._facadeBlobStorage.GetBlob(this.storeId, idPhoto).subscribe(
          (result) => {
            if (result.completed) {
              const photo = "data:image/png;base64," + result.data.fileBase64;
              this.photos_gallery.push(photo);
              this.loading = false;
              this.photoModal.show();
                  console.log("idcode: " + this.idcode + " storeid: " + this.storeId + "org: " + this.organizationId)
            } else {
              this.loading = false;
              this.addAlert(
                this.strings.GetText(res.FailedToGetImages),
                "danger"
              );
            }
          },
          (error) => {
            this.loading = false;
            this.addAlert(
              this.strings.GetText(res.FailedToGetImages),
              "danger"
            );
          }
        );
      });
    } else {
      this.loading = false;
    }
  }

  arrayBufferToBase64(buffer) {
    const TYPED_ARRAY = new Uint8Array(buffer);
    const STRING_CHAR = String.fromCharCode.apply(null, TYPED_ARRAY);
    return btoa(STRING_CHAR);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (
          item[keys[i]] != null &&
          (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)
        ) {
          return true;
        }
      }
    });
  }
}
